export default __webpack_public_path__ + "static/media/02.2abb512e.jpg";